<template>
  <div class="page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="container header-inner">
        <div class="logo-wrap">
          <img class="logo" src="@/assets/text-logo.png" alt="logo" />
          <!-- <div class="logo-text">
            <div class="title">智捷互聯數智科技有限公司</div>
            <div class="sub">ZHJ INTELLIGENT MARKETING TECHNOLOGY LIMITED</div>
          </div> -->
          <!-- PC 導航 -->
          <!-- <nav class="nav pc-only">
            <a href="#about">關於我們</a>
            <a href="#services">聯絡我們</a>
            <a href="#contact">加入我們</a>
          </nav> -->
        </div>
         <!-- 右上角電話 -->
         <div class="tel pc-only">
         
         <a href="https://tkzl.zhonglianhuashu.com/marketing-client/auth/login" target="_blank" rel="noopener noreferrer">会员登录</a>
       </div>
  

        <!-- 移動端菜單 -->
        <div class="mobile-menu-toggle mobile-only" @click="menuOpen = !menuOpen"><span></span><span></span><span></span></div>
      </div>

      <!-- 移動端下拉菜單 -->
      <transition name="fade">
        <nav class="nav mobile-nav mobile-only" v-if="menuOpen">
          <a href="#services" @click="closeMenu">解決方案</a>
          <a href="#business" @click="closeMenu">核心業務</a>
          <a href="#about" @click="closeMenu">關於我們</a>
          <a href="#contact" @click="closeMenu">加入我們</a>
        </nav>
      </transition>
    </header>

    <!-- 首屏 Hero 區 -->
    <section class="hero">
      <div class="hero-bg"></div>
      <div class="container hero-inner">
        <div class="hero-text">
          <h1>
            全國領先的以
            <span class="highlight">「AI+大數據」</span>
            <br />
            驅動的數智科技企業
          </h1>
          <p class="hero-sub">FULL-CHAIN DIGITAL MARKETING SERVICES</p>
        </div>
      </div>
    </section>

    <!-- 四個統計卡片 -->
    <!-- <section class="stats" id="services">
      <div class="container stats-grid">
        <div class="stat-card" :class="index % 2 === 1 ? 'stat-card1' : 'stat-card0'" v-for="(item, index) in stats" :key="item.title">
          <div class="left">
            <img :src="item.icon" class="icon" alt="" />
            <div class="desc">
              <div class="stat-number">{{ item.number }}</div>
              <div class="stat-desc">{{ item.desc }}</div>
            </div>
          </div>
          <img :src="item.img" class="descImg" alt="" />
        </div>
      </div>
    </section> -->

    <!-- 核心業務 -->
    <section class="section" id="business">
      <div class="container">
        <div class="section-header">
          <img :src="hxyw" alt="" />
        </div>
        <div class="card-grid">
          <div class="business-card" v-for="item in business" :key="item.title">
            <div class="imgBox">
              <img :src="item.img" class="icon" alt="icon" />
            </div>

            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 關於我們 -->
    <section class="section about" id="about">
      <div class="container">
        <div class="section-header">
          <img :src="gywm" alt="" />
        </div>
        <div class="about-inner">
          <div class="about-text">
            <img :src="aboutLogo" alt="" class="aboutLogo" />
            <p class="about-desc">從基礎帳戶管理到全鏈路數位行銷服務，逐步建立「工具+服務+營運」的一體化商業平台。</p>
            <!-- <button class="btn-primary sm">聯絡我們</button> -->
          </div>
          <div class="about-image">
            <img src="@/assets/aboutBg.png" alt="building" />
          </div>
        </div>
      </div>
    </section>

    <!-- 聯繫 & 底部 -->
    <Footer />
  </div>
</template>

<script>
import icon0 from '@/assets/icon0.svg'
import icon1 from '@/assets/icon1.svg'
import icon2 from '@/assets/icon2.svg'
import desc0 from '@/assets/desc0.png'
import desc1 from '@/assets/desc1.png'
import desc2 from '@/assets/desc2.png'
import hxyw from '@/assets/hxyw.png'
import yewu0 from '@/assets/yewu0.png'
import yewu1 from '@/assets/yewu1.png'
import yewu2 from '@/assets/yewu2.png'
import yewu3 from '@/assets/yewu3.png'
import gywm from '@/assets/aboutUs.png'
import aboutLogo from '@/assets/aboutLogo.png'
import aboutBg from '@/assets/aboutBg.png'
import Footer from '@/components/footer'
export default {
  name: 'App',
  components: { Footer },
  data() {
    return {
      menuOpen: false,
      hxyw,
      gywm,
      aboutLogo,
      aboutBg,
      stats: [
        {
          number: '5000家+',
          desc: '累計服務客戶',
          icon: icon0,
          img: desc0
        },
        {
          number: '500人+',
          desc: '目前企業規模',
          icon: icon1,
          img: desc1
        },
        {
          number: '200项',
          desc: '已獲得各類獎項',
          icon: icon2,
          img: desc2
        }
      ],
      business: [
        {
          title: '技術驅動',
          desc: '擁有自研數智化平台與智慧機器人系統，提升服務效率與自動化水準。',
          img: yewu0
        },
        {
          title: '多平台資源整合',
          desc: '身為媒體代理商，具備豐富的流量資源與通路優勢。',
          img: yewu1
        },
        {
          title: '業界深耕經驗',
          desc: '在電商、日化、食品飲料、美妝等領域有成熟合作案例與產業理解。',
          img: yewu2
        },
        {
          title: '全鏈路服務能力',
          desc: '從策略諮詢到投放執行、帳戶管理，提供一站式服務支援。',
          img: yewu3
        }
      ]
    }
  },
  methods: {
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>
/* 基礎樣式 */
* {
  box-sizing: border-box;
}

.page {
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang TC', 'Microsoft JhengHei', 'Helvetica Neue', Arial, sans-serif;
  color: #1f2933;
  background: #fff;
}

a {
  text-decoration: none;
  color: inherit;
}

.container {
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 16px;
}

/* ------------------ header ------------------ */

.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

.logo-wrap {
  display: flex;
  align-items: center;
  /* flex: 1; */
}

.logo {
  width: 300px;
  margin-right: 80px;
}

.logo-text .title {
  font-size: 14px;
  font-weight: 600;
}

.logo-text .sub {
  font-size: 10px;
  color: #8a94a6;
}

.nav {
  display: flex;
  gap: 24px;
  font-size: 14px;
}

.nav a {
  position: relative;
  padding-bottom: 4px;
}

.nav a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #4d7bff, #5fd4ff);
  transition: width 0.2s ease;
}

.nav a:hover::after {
  width: 100%;
}

.tel {
  /* margin-left: 24px; */
  padding: 6px 12px;
  border-radius: 8px;
  /* border: 1px solid #4d7bff; */
  font-size: 13px;
  color: #111;
  background: #e9f2fe;
  display: flex;
  align-items: center;
}
.tel .icon {
  width: 20px;
  margin-right: 5px;
}

/* 移動端菜單按鈕 */
.mobile-menu-toggle {
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.mobile-menu-toggle span {
  display: block;
  height: 2px;
  border-radius: 999px;
  background: #1f2933;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  padding: 8px 16px 12px;
  border-top: 1px solid #e5edff;
  background: #ffffff;
}

.mobile-nav a {
  padding: 8px 0;
  font-size: 14px;
}

/* ------------------ hero ------------------ */

.hero {
  position: relative;
  overflow: hidden;
  /* background: radial-gradient(circle at 0 0, #e4f0ff 0, #ffffff 45%, #f1f5ff 100%); */
  /* F7FDF9 */
  /* F3FFFF */
  background: linear-gradient(135deg, #f7fdf9, #fff);
}

.hero-bg {
  /* position: absolute;
  inset: 0;
  background-image: url("@/assets/hero-bg.png");
  background-size: cover;
  background-position: center;
  opacity: 0.08;
  pointer-events: none; */
}

.hero-inner {
  position: relative;
  display: flex;
  padding: 100px 150px 60px;
  align-items: center;
  background-image: url('@/assets/hero-bg.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.hero-text {
  flex: 3;
  max-width: 640px;
}

.hero-text h1 {
  font-size: 32px;
  line-height: 1.4;
  font-weight: 700;
  color: #111827;
}

.highlight {
  color: #297eff;
}

.hero-sub {
  margin-top: 8px;
  font-size: 13px;
  letter-spacing: 0.1em;
  color: #7b88a1;
}

.hero-desc {
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.7;
  color: #4b5563;
}

.hero-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
}

.btn-primary,
.btn-ghost {
  min-width: 120px;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.15s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #4d7bff, #5fd4ff);
  color: #ffffff;
  box-shadow: 0 10px 25px rgba(77, 123, 255, 0.35);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 30px rgba(77, 123, 255, 0.45);
}

.btn-ghost {
  background: #ffffff;
  color: #2760ff;
  border: 1px solid #d0ddff;
}

.btn-ghost:hover {
  background: #f3f6ff;
}

.btn-primary.sm {
  min-width: 104px;
  padding: 8px 16px;
  font-size: 13px;
}

/* 右側大標題區 */
.hero-graphic {
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-main-text {
  font-size: 40px;
  font-weight: 800;
  letter-spacing: 0.12em;
  background: linear-gradient(135deg, #2e72ff, #5fd4ff);
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: 0 10px 20px rgba(46, 114, 255, 0.45);
}

.hero-chip {
  margin-top: 20px;
  width: 220px;
  height: 120px;
  border-radius: 30px;
  background: radial-gradient(circle at 20% 0, #ffffff 0, #e0ecff 40%, #d1f5ff 100%);
  box-shadow: 0 15px 35px rgba(36, 99, 255, 0.3);
}

/* ------------------ stats ------------------ */

.stats {
  margin-top: 40px;
  padding-bottom: 40px;
}

.stats-grid {
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-card {
  border-radius: 20px;
  padding: 18px 40px;
  min-width: 380px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.stat-card0 {
  background: linear-gradient(154.24deg, #f0f6ff 1.98%, #e5effe 50.61%, #b7d9fe 100%);
}
.stat-card1 {
  background: linear-gradient(155.55deg, #f2fbff 3.85%, #f3fbff 51.61%, #d7faff 102.64%);
}
.stat-card .left {
  display: flex;
  align-items: center;
}
.stat-card .left .icon {
  margin-right: 20px;
}
.stat-card .descImg {
  width: 80px;
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 16px;
  background: linear-gradient(135deg, #4d7bff, #5fd4ff);
  opacity: 0.92;
  margin-bottom: 12px;
}

.stat-number {
  font-size: 18px;
  font-weight: 700;
  color: #0d0d0e;
}

.stat-title {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 600;
}

.stat-desc {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
}

/* ------------------ 通用 section ------------------ */

.section {
  padding: 35px 0;
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
}
.section-header img {
  width: 300px;
  text-align: center;
}

.section-header h2 {
  font-size: 22px;
  font-weight: 700;
}

.section-header p {
  font-size: 12px;
  letter-spacing: 0.15em;
  color: #9ca3af;
}

/* 核心業務卡片 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.business-card {
  background: #f9fbff;
  border-radius: 20px;
  padding: 50px 30px;
  /* box-shadow: 0 8px 18px rgba(15, 35, 95, 0.05); */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.business-card .imgBox {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  margin-bottom: 60px;
}
.business-card .icon {
  width: 120px;
}

.business-card h3 {
  font-size: 16px;
  color: #0d0d0e;
  margin-bottom: 8px;
}

.business-card p {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}

/* 關於我們 */
.about {
  /* background: linear-gradient(180deg, #f3f6ff, #ffffff); */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.about .section-header img {
  width: 150px;
}

.about-inner {
  display: flex;
  align-items: center;
  gap: 32px;
  background: linear-gradient(180.22deg, #fafcff -2.86%, #f4f9ff 99.8%);
  border-radius: 20px;
  padding: 50px 60px;
}

.about-text .aboutLogo {
  width: 350px;
}
.about-inner .btn-primary {
  background: #1a41e7;
  border-radius: 8px;
}

.about-text h2 {
  font-size: 22px;
  font-weight: 700;
}

.about-en {
  margin-top: 4px;
  font-size: 12px;
  letter-spacing: 0.18em;
  color: #9ca3af;
}

.about-name {
  margin-top: 16px;
  font-size: 15px;
  font-weight: 600;
}

.about-desc {
  margin-top: 10px;
  font-size: 13px;
  color: #4b5563;
  line-height: 1.8;
  max-width: 480px;
}

.about-image {
  flex: 2;
}

.about-image img {
  width: 100%;
  /* border-radius: 20px; */
  object-fit: cover;
  box-shadow: 0 15px 35px rgba(15, 35, 95, 0.2);
}

/* footer */

.footer {
  margin-top: 16px;
  background: linear-gradient(180.22deg, #fafcff -2.86%, #f4f9ff 99.8%);
  font-size: 12px;
  color: #6b7280;
}

.footer-main {
  display: flex;
  gap: 32px;
  padding: 32px 16px 20px;
}

.footer-col {
  flex: 1;
}

.footer-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #111827;
}

.footer-col a {
  display: block;
  margin-bottom: 4px;
  cursor: pointer;
}

.qrcode-wrap {
  display: flex;
  gap: 12px;
}

.qrcode {
  width: 60px;
  height: 60px;
  background: #e5e7eb;
  border-radius: 10px;
}

.footer-bottom {
  text-align: center;
  padding: 8px 16px 16px;
  border-top: 1px solid #e5edff;
  font-size: 11px;
}

/* 顯示/隱藏 PC & Mobile 元素 */
.pc-only {
  display: flex;
}

.mobile-only {
  display: none;
}

/* 動畫 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ------------------ 響應式 ------------------ */

@media (max-width: 1024px) {
  .hero-inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .hero-graphic {
    margin-top: 24px;
    align-items: flex-start;
  }
  .hero-main-text {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .pc-only {
    display: none !important;
  }
  .mobile-only {
    display: flex !important;
  }
  .header-inner {
    height: 56px;
  }

  .hero-inner {
    padding: 40px 16px 32px;
  }
  .hero-text h1 {
    font-size: 22px;
  }
  .hero-sub {
    font-size: 11px;
  }
  .hero-desc {
    font-size: 13px;
  }
  .hero-actions {
    flex-direction: row;
  }
  .hero-graphic {
    align-items: center;
    width: 100%;
  }
  .hero-main-text {
    font-size: 26px;
  }
  .hero-chip {
    width: 180px;
    height: 96px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 8px;
  }

  .section {
    padding: 32px 0;
  }
  .card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .about-inner {
    flex-direction: column;
  }
  .about-desc {
    max-width: none;
  }

  .footer-main {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  .card-grid {
    grid-template-columns: 1fr;
  }
  .hero-actions {
    flex-direction: column;
    align-items: flex-start;
  }
  .btn-primary,
  .btn-ghost {
    width: 100%;
    text-align: center;
  }
}
</style>
